class CountdownTimer {
    constructor(element) {
        this.element = element;
        this.targetDate = this.parseBritishDateTime(element.dataset.countdown);
        this.interval = null;
        
        if (!this.targetDate || isNaN(this.targetDate.getTime())) {
            console.error('Invalid date format. Please use DD/MM/YYYY HH:mm');
            this.element.innerHTML = 'Invalid date';
            return;
        }
    }

    parseBritishDateTime(dateStr) {
        try {
            const [datePart, timePart] = dateStr.split(' ');
            if (!datePart) return null;

            const [day, month, year] = datePart.split('/');
            const [hours, minutes] = timePart ? timePart.split(':') : ['00', '00'];
            
            if ([day, month, year, hours, minutes].some(part => isNaN(parseInt(part)))) {
                return null;
            }

            const date = new Date(Date.UTC(
                parseInt(year),
                parseInt(month) - 1,
                parseInt(day),
                parseInt(hours) - (this.getBritishTimezoneOffset() / 60),
                parseInt(minutes)
            ));

            return isNaN(date.getTime()) ? null : date;
        } catch (e) {
            console.error('Error parsing date:', e);
            return null;
        }
    }

    getBritishTimezoneOffset() {
        try {
            const now = new Date();
            const britishFormatter = new Intl.DateTimeFormat('en-GB', {
                timeZone: 'Europe/London',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            });
            
            const londonTime = britishFormatter.format(now);
            const [londonHours, londonMinutes] = londonTime.split(':').map(Number);
            
            const localHours = now.getHours();
            const localMinutes = now.getMinutes();
            
            const diffInMinutes = ((londonHours - localHours) * 60) + (londonMinutes - localMinutes);
            return -diffInMinutes;
        } catch (e) {
            console.error('Error calculating timezone offset:', e);
            return 0;
        }
    }

    getTimeRemaining() {
        const now = new Date();
        const total = this.targetDate - now;
        
        if (isNaN(total)) {
            return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
        }

        const days = Math.max(0, Math.floor(total / (1000 * 60 * 60 * 24)));
        const hours = Math.max(0, Math.floor((total % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        const minutes = Math.max(0, Math.floor((total % (1000 * 60 * 60)) / (1000 * 60)));
        const seconds = Math.max(0, Math.floor((total % (1000 * 60)) / 1000));
        
        return {
            total,
            days,
            hours,
            minutes,
            seconds
        };
    }

    formatNumber(number) {
        return (number || 0).toString().padStart(2, '0');
    }

    init() {
        if (!this.targetDate) return;
        this.element.innerHTML = '<div class="countdown-inner"></div>';
        this.updateTimer();
        this.interval = setInterval(() => this.updateTimer(), 1000);
    }

    createTimeElement(value, label) {
        return `
            <div class="countdown-segment">
                <div class="countdown-value">${this.formatNumber(value)}</div>
                <div class="countdown-label">${label}</div>
            </div>
        `;
    }

    updateTimer() {
        const t = this.getTimeRemaining();
        const innerElement = this.element.querySelector('.countdown-inner');

        if (t.total <= 0) {
            clearInterval(this.interval);
            innerElement.innerHTML = `
                ${this.createTimeElement(0, 'Hours')}
                <div class="countdown-separator">:</div>
                ${this.createTimeElement(0, 'Minutes')}
                <div class="countdown-separator">:</div>
                ${this.createTimeElement(0, 'Seconds')}
            `;
            return;
        }

        let timerHtml = '';
        
        // Only show days if we have them
        if (t.days > 0) {
            innerElement.classList.add('has-days');
            timerHtml += `
                ${this.createTimeElement(t.days, 'Days')}
                <div class="countdown-separator">:</div>
            `;
        } else {
            innerElement.classList.remove('has-days');
        }

        timerHtml += `
            ${this.createTimeElement(t.hours, 'Hours')}
            <div class="countdown-separator">:</div>
            ${this.createTimeElement(t.minutes, 'Minutes')}
            <div class="countdown-separator">:</div>
            ${this.createTimeElement(t.seconds, 'Seconds')}
        `;

        innerElement.innerHTML = timerHtml;
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
}

const initCountdownTimers = () => {
    const timers = document.querySelectorAll('[data-countdown]');
    timers.forEach(timerElement => {
        const timer = new CountdownTimer(timerElement);
        timer.init();
    });
};